import { ResponsiveBreakpoint } from "@utils/StyleConstants";
import classNames from "classnames";
import React from "react";

export const CollectionAttribute = ({
  label,
  value,
  size = "medium",
  className,
}: {
  label: string;
  value: string;
  size?: "small" | "medium";
  className?: string;
}) => {
  return (
    <div className={classNames("collection-attribute", size, className)}>
      <div className="label">{label}</div>
      <div className="value high-legibility">{value}</div>

      <style jsx>{`
        .label {
          color: var(--tertiary-color);
        }

        .value {
          color: var(--primary-color);
        }

        .medium {
          font-weight: var(--font-weight-medium);

          .label {
            font-size: var(--font-size-sm);
          }

          .value {
            font-size: var(--font-size-lg);

            @media (max-width: ${ResponsiveBreakpoint.medium}) {
              font-size: var(--normal-font-size);
            }
          }
        }

        @media (max-width: ${ResponsiveBreakpoint.small}) {
          .medium {
            .label {
              font-size: var(--font-size-xs);
            }

            .value {
              font-size: var(--font-size-regular);
            }
          }
        }
      `}</style>
    </div>
  );
};
